"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinInducingAsteroid = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var constants_1 = require("../../constants");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var AphroditeRebalanced_1 = require("../rebalanced/rebalanced_corporation/AphroditeRebalanced");
var SpinInducingAsteroid = (function (_super) {
    __extends(SpinInducingAsteroid, _super);
    function SpinInducingAsteroid() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.SPIN_INDUCING_ASTEROID,
            cost: 16,
            tags: [Tags_1.Tags.SPACE],
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.venus(10).max(); }),
            metadata: {
                cardNumber: '246',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.venus(2);
                }),
                description: 'Venus must be 10% or lower. Raise Venus 2 steps.',
            },
        }) || this;
    }
    SpinInducingAsteroid.prototype.canPlay = function (player) {
        if (!_super.prototype.canPlay.call(this, player)) {
            return false;
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player.game, PartyName_1.PartyName.REDS)) {
            var adjustedCost = player.getCardCost(this) + constants_1.REDS_RULING_POLICY_COST * 2 - AphroditeRebalanced_1.AphroditeRebalanced.rebalancedAphroditeBonus(player, 2);
            return player.canAfford(adjustedCost, { titanium: true });
        }
        return true;
    };
    SpinInducingAsteroid.prototype.play = function (player) {
        player.game.increaseVenusScaleLevel(player, 2);
        return undefined;
    };
    return SpinInducingAsteroid;
}(Card_1.Card));
exports.SpinInducingAsteroid = SpinInducingAsteroid;
//# sourceMappingURL=SpinInducingAsteroid.js.map